<template>
  <div class="section-main__warp">
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
      @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      <template slot="menu" slot-scope="scope">
        <!-- <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="iconfont icon-Detail" @click="handleView(scope.row, scope.index)"></el-button>
        </el-tooltip> -->
        <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-tickets" @click="handleView(scope.row, scope.index)"
            style="font-size: 16px; color: #407aee; cursor: pointer; margin: 0 4px"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="确认" placement="top" popper-class="tooltip-draw"
          v-if="scope.row.taskStates == '3'">
          <i class="el-icon-circle-check" @click="handleConfirm(scope.row, scope.index)"
            style="font-size: 16px; color: #407aee; cursor: pointer; margin: 0 4px"></i>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog title="任务派单详情" :visible.sync="detailVisible" append-to-body :close-on-click-modal="modalClose" width="42%">
      <el-descriptions border column="2">
        <el-descriptions-item label="任务编号">{{
          detailForm.taskCode
        }}</el-descriptions-item>
        <el-descriptions-item label="任务名称">{{
          detailForm.taskName
        }}</el-descriptions-item>
        <el-descriptions-item label="任务状态">
          <el-tag size="small" type="warning">{{
            taskStatesRender(detailForm.taskStates)
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="是否逾期">
          <el-tag size="small" type="warning">{{
            taskExceedRender(detailForm.taskExceed)
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="紧急程度">
          <el-tag size="small" type="warning">{{
            taskLevelRender(detailForm.taskLevel)
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="派发日期">{{
          detailForm.createTime
        }}</el-descriptions-item>
        <el-descriptions-item label="要求完成时间">{{
          detailForm.taskTime
        }}</el-descriptions-item>
        <el-descriptions-item label="执行人员">{{
          detailForm.personName
        }}</el-descriptions-item>
        <el-descriptions-item label="处理要求">{{
          detailForm.taskAsk
        }}</el-descriptions-item>
        <el-descriptions-item label="完成时间" v-if="detailForm.taskStates == 3">{{
          detailForm.finishTime
        }}</el-descriptions-item>

        <el-descriptions-item label="是否客户支付费用" v-if="detailForm.taskStates == 3">{{ detailForm.cost == 1 ? "是" : "否"
        }}</el-descriptions-item>
        <el-descriptions-item label="预估金额/元" v-if="detailForm.taskStates == 3">{{
          detailForm.amount
        }}</el-descriptions-item>
        <el-descriptions-item label="是否更换配件" v-if="detailForm.taskStates == 3">{{
          detailForm.renewal == 1 ? "是" : "否"
        }}</el-descriptions-item>
        <el-descriptions-item label="配件列表" v-if="detailForm.taskStates == 3">{{
          detailForm.accessory
        }}</el-descriptions-item>
        <el-descriptions-item label="客户是否认可费用" v-if="detailForm.taskStates == 3">{{ detailForm.approve == 1 ? "是" : "否"
        }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="detailForm.taskStates == 3 && detailForm.approve == 1">
        <div style="margin: 10px 0 5px 0">客户手签：</div>
        <div style="display: flex">
          <el-image style="width: 100px; height: 100px" :src="getImgPath(detailForm.manually)"
            :preview-src-list="[getImgPath(detailForm.manually)]"></el-image>
        </div>
      </div>
      <div v-if="detailForm.taskStates == 3">
        <div style="margin: 10px 0 5px 0">反馈描述：</div>
        <el-input type="textarea" :rows="2" v-model="detailForm.taskFeedback" readonly></el-input>
      </div>
      <div v-if="detailForm.taskStates == 3 && detailForm.reportImagesArr.length > 0">
        <div style="margin: 10px 0 5px 0">反馈图片：</div>
        <div style="display: flex">
          <div v-for="item in detailForm.reportImagesArr" :key="item" style="margin: 0 10px 10px 0">
            <el-image style="width: 100px; height: 100px" :src="getImgPath(item)"
              :preview-src-list="[getImgPath(item)]"></el-image>
          </div>
        </div>
      </div>
      <div v-if="detailForm.taskStates == 3 && detailForm.reportVideoArr.length > 0">
        <div style="margin: 10px 0 5px 0">反馈视频：</div>
        <div style="display: flex">
          <div v-for="item in detailForm.reportVideoArr" :key="item" style="margin: 0 10px 10px 0">
            <video style="width: 300px; height: 180px" :src="getImgPath(item)" controls="controls"></video>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import tableOption from "../config/distributeTable";
import { formatTimeToStr } from "../filter/dateUtils";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      option: tableOption(this),
      tableData: [],
      searchForm: {},
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      detailVisible: false,
      modalClose: false,
      detailForm: {
        taskCode: "",
        taskName: "",
        taskStates: "",
        taskExceed: "",
        taskLevel: "",
        createTime: "",
        taskTime: "",
        taskAsk: "",
        personName: "",
        finishTime: "",
        taskFeedback: "",
        reportImagesArr: [],
        reportVideoArr: [],
      },
    };
  },
  created() { },
  mounted() {
    this.getList();
  },
  methods: {
    handleUpdate() {
      this.getList();
    },
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNo: this.page.currentPage,
        pageSize: this.page.pageSize,
        reportCode: this.searchForm.reportCode,
        taskCode: this.searchForm.taskCode,
        taskName: this.searchForm.taskName,
        taskExceed: this.searchForm.taskExceed,
        taskLevel: this.searchForm.taskLevel,
        taskStates: this.searchForm.taskStates,
      };
      if (this.searchForm.createTime && this.searchForm.createTime.length > 0) {
        params.startDate = formatTimeToStr(this.searchForm.createTime[0]);
        params.endDate = formatTimeToStr(this.searchForm.createTime[1]);
      }
      this.$fetch(api.queryEventTaskPage, params).then((response) => {
        if (response.success) {
          this.tableData = response.data.list;
          this.page.total = response.data ? response.data.total : 0;
        } else {
          this.$message.error(response.msgContent || "获取任务派单列表失败");
        }
      });
    },
    handleView(row) {
      this.detailForm.cost = row.cost;
      this.detailForm.approve = row.approve;
      this.detailForm.amount = row.amount;
      this.detailForm.accessory = row.accessory;
      this.detailForm.renewal = row.renewal;

      this.detailForm.manually = row.manually;
      this.detailForm.taskCode = row.taskCode;
      this.detailForm.taskName = row.taskName;
      this.detailForm.taskStates = row.taskStates;
      this.detailForm.taskExceed = row.taskExceed;
      this.detailForm.taskLevel = row.taskLevel;
      this.detailForm.createTime = row.createTime;
      this.detailForm.taskTime = row.taskTime;
      this.detailForm.taskAsk = row.taskAsk;
      this.detailForm.personName = row.personName;
      this.detailForm.finishTime = row.finishTime;
      this.detailForm.taskFeedback = row.taskFeedback;
      if (row.taskImages && row.taskImages != "") {
        this.detailForm.reportImagesArr = row.taskImages.split(",");
      } else {
        this.detailForm.reportImagesArr = [];
      }
      if (row.taskVideos && row.taskImages != "") {
        this.detailForm.reportVideoArr = row.taskVideos.split(",");
      } else {
        this.detailForm.reportVideoArr = [];
      }
      this.detailVisible = true;
    },
    detailCancel() {
      this.detailForm.taskCode = "";
      this.detailForm.renewal = "";
      this.detailForm.manually = "";
      this.detailForm.cost = "";
      this.detailForm.approve = "";
      this.detailForm.amount = "";
      this.detailForm.accessory = "";
      this.detailForm.taskName = "";
      this.detailForm.taskStates = "";
      this.detailForm.taskExceed = "";
      this.detailForm.taskLevel = "";
      this.detailForm.createTime = "";
      this.detailForm.taskTime = "";
      this.detailForm.taskAsk = "";
      this.detailForm.personName = "";
      this.detailForm.finishTime = "";
      this.detailForm.taskFeedback = "";
      this.detailForm.reportImagesArr = [];
      this.detailForm.reportVideoArr = [];
      this.detailVisible = false;
    },
    handleConfirm(row) {
      const params = {
        taskCode: row.taskCode
      };
      this.$confirm("是否确认已完成此任务?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/bms/manage/reportEvent/examineTask.json', params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    },
    getImgPath(item) {
      return item ? utils.Bus.imgPath(item) : "";
    },
    taskStatesRender: function (value) {
      if (Number(value) === 1) {
        return "待接单";
      } else if (Number(value) === 2) {
        return "进行中";
      } else if (Number(value) === 3) {
        return "待确认";
      } else if (Number(value) === 4) {
        return "已完成";
      }
      return "";
    },
    taskExceedRender: function (value) {
      if (Number(value) === 0) {
        return "未逾期";
      } else if (Number(value) === 1) {
        return "已逾期";
      }
      return "";
    },
    taskLevelRender: function (value) {
      if (Number(value) === 1) {
        return "特急";
      } else if (Number(value) === 2) {
        return "紧急";
      } else if (Number(value) === 3) {
        return "一般";
      }
      return "";
    },
  },
};
</script>
